import { render, staticRenderFns } from "./FasilitasPeralatan.vue?vue&type=template&id=6a737164&scoped=true"
import script from "./FasilitasPeralatan.vue?vue&type=script&lang=js"
export * from "./FasilitasPeralatan.vue?vue&type=script&lang=js"
import style0 from "./FasilitasPeralatan.vue?vue&type=style&index=0&id=6a737164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a737164",
  null
  
)

export default component.exports